enum Routes {
  DEFAULT = "*",
  HOME = "/",
  COMPLETE_YOUR_LOOK = "complete-your-look",
  LOOKS_BY_ANCHOR_GARMENT = "complete-your-look/:anchorProductVariantId",
  CATEGORIES = "categories",
  CATEGORY = "categories/:categoryId",
  CHECKOUT_CONFIRMATION = "checkout-confirmation/:orderId",
  CHECKOUT = "checkout",
  ORDERS = "orders",
  SALES = "sales",
  SALE = "sales/:categoryId",
  WISHLIST = "wishlist",
  CART = "cart",
  PRODUCT_DETAIL = "detail/:variantId",
  PRODUCT_LOOK_DETAIL = "look/:lookId/detail/:variantId",
  PRODUCT_CATEGORY_DETAIL = "category/:categoryId/detail/:variantId",
  RETURN_CONFIRMATION = "orders/return-confirmation/:orderId",
  ORDER = "orders/:orderId",
  TRENDING_FOR_YOU = "trending-for-you",
}

const PRIMARY_ROUTES = [Routes.COMPLETE_YOUR_LOOK, Routes.CATEGORIES, Routes.SALES];

export { Routes, PRIMARY_ROUTES };
